<template>
  <ul class="list-disc pl-5 space-y-1">
    <li v-for="(item, index) in items" :key="index" class="text-sm text-gray-700">
      <template v-if="typeof item === 'object' && item !== null">
        <RichObjectDisplay :data="item" />
      </template>
      <template v-else>
        {{ item }}
      </template>
    </li>
  </ul>
</template>

<script>
import RichObjectDisplay from './RichObjectDisplay.vue'; // Assumed for nested objects

export default {
  name: 'RichListDisplay',
  components: {
    RichObjectDisplay 
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  }
};
</script>

<style scoped>
/* Add any specific styling if needed */
</style> 